import { ConfirmEmailForm } from '@features/auth/confirm-email';

import { createView } from '@shared/lib/view';

const ConfirmEmailTimeoutPage = createView().view(() => (
  <ConfirmEmailForm timeout />
));

export { ConfirmEmailTimeoutPage };
